import React from "react";
import IconSafety from "../../assets/icons/safety.svg";
import IconDignity from "../../assets/icons/dignity.svg";
import IconStaff from "../../assets/icons/trained-staff.svg";

const features = [
  {
    icon: IconSafety,
    title: "Prioritise Safety",
    description:
      "Your loved one’s well-being is our top priority. From everyday routines to emergencies, we’re always looking out for their safety, so you can breathe a little easier.",
  },
  {
    icon: IconDignity,
    title: "Dignity",
    description:
      "Everyone deserves to be treated with kindness and respect. We listen, we understand, and we support without ever taking away their independence or voice.",
  },
  {
    icon: IconStaff,
    title: "Trained Professionals",
    description:
      "Our team is not only well-trained-they’re warm, patient, and truly passionate about caregiving. It’s not just a job to us, it’s personal.",
  },
];

const WhyChooseUsSection = () => {
  return (
    <section className="px-4 font-poppins mb-[50px]">
      <div className="max-w-screen-xl mx-auto text-center">
        <h2 className="text-[var(--primary-orange-color)] text-xl sm:text-2xl md:text-4xl font-semibold mb-12 uppercase">
          Why Choose Us?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-3">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center px-2 group">
              <div className="bg-green group-hover:bg-[var(--primary-orange-color)] transition-colors duration-300 rounded-full flex items-center justify-center z-10 p-5">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="w-[40px] h-[40px] md:w-[60px] md:h-[60px]"
                />
              </div>
              <div className="w-full h-full -mt-10 z-0 rounded-2xl group-hover:shadow-[4px_4px_32px_var(--background-blue-color)] pb-10">
                <h3 className="text-[24px] lg:text-[32px] xl:text-[36px] font-semibold text-green mt-14 sm:mt-[64px] mb-4 sm:mb-[29px]">
                  {feature.title}
                </h3>
                <p className="text-[12px] lg:text-[20px] xl:text-[20px] font-light text-[var(--light-gray-color)] px-10">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
